// Load vendors
import { accountReducer, isAuthReducer } from 'app/actions/authActions';
import { homeDataReducer } from 'app/routes/Dashboard/actions/home';
import { pollsReducer } from 'app/routes/Dashboard/actions/polls';
import { productsReducer } from 'app/routes/Dashboard/actions/products';
import { projectImagesReducer, projectReducer } from 'app/routes/Dashboard/actions/projects';
import { projectItemsRelationsReducer } from 'app/routes/Dashboard/actions/projectItems';
import { followsReducer } from 'app/routes/Dashboard/actions/user';
import { combineReducers } from 'redux';

const rootReducer = combineReducers({
  isAuthenticated: isAuthReducer,
  account: accountReducer,
  projects: projectReducer,
  products: productsReducer,
  projectItems: projectItemsRelationsReducer,
  projectImages: projectImagesReducer,
  follows: followsReducer,
  polls: pollsReducer,
  home: homeDataReducer,
});

export default rootReducer;
